import classNames from 'classnames';

import CustomStateLabel from '../../../common/custom-state-label';
import MotorcycleIcon from '../../../../assets/images/icons/onTheWayRT.webp';

import useStyles from './OnTheWayRTStateLabel.styles';

const OnTheWayRTStateLabel = ({ classes, ...props }) => {
  const componentClasses = useStyles();

  return (
    <CustomStateLabel
      classes={{
        root: classNames(componentClasses.root, classes.root),
        iconRoot: classNames(componentClasses.iconRoot, classes.iconRoot),
      }}
      Icon={MotorcycleIcon}
      {...props}
    />
  );
};

export default OnTheWayRTStateLabel;
